<div [id]="getWidgetId()">
    @if (isModalForm()) {
        <div class="form-root payment-form-content" [class]="rootCssClasses()" [style]="rootCssVars()">
            <div class="form-button-wrapper form-vertical button-without-form" [style]="buttonCssVars()">
                <a [class]="getButtonStyles(formButtonSettings())">
                    @if (formButtonSettings().buttonIcon?.isActive) {
                        <span class="icon" [innerHTML]="getIcon(formButtonSettings().buttonIcon?.icon)"></span>
                    }
                    {{ formButtonSettings().label }}
                </a>
            </div>
        </div>
    }
    @if (isStaticForm()) {
        <web-payment-static-form-view
            [widgetData]="data()"
            [isZero]="isZero()"
            [isMobile]="isDeviceMobileSig()"
            [isTablet]="isDeviceTabletSig()"
        />
    }
</div>
